import React from 'react';
import { Grid, Row, Col, Panel, Image, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { Buckets } from '../containers/Waitlist/WaitlistFilters/BucketFilters'
import Loading from '../components/Loading';
import Helpers, { handleHttpResponse } from '../lib/Helpers';
import DateHelpers from '../lib/DateHelpers'
import UserPanelOffWaitlistCol from './UserPanelOffWaitlistCol'




class UserPanel extends React.Component {

    state = {
        notes: this.props.user.waitlist_entry.notes,
        action_notes: this.props.user.waitlist_entry.action_notes,
        assignee: this.props.user.waitlist_entry.assignee,
        bucket: this.props.user.waitlist_entry.bucket,
        completion: this.props.user.waitlist_entry.completion,
        loading: false,
        waitlisted: true
    }

    edit(key, value) {
        let newState = {};
        newState[key] = value;
        this.setState(Object.assign({}, newState, { loading: true }));
        const self = this;
        const update = this.props.user.updateWaitlistEntry(newState);
        update.then(function(response) {
            return handleHttpResponse(response)
                .then(function(result) {
                    self.setState({ loading: false });
                }).catch(function(err) {
                    console.log(err);
                    self.setState({ loading: false });
                })
        }).catch(function(err) {
            console.log("There was an error, please try again");
            self.setState({ loading: false });
            //**TODO: send response over to SC engineers
        })
    }

    organizationText() {
        let organizationText = '';
        if (this.props.user.organization && this.props.user.organization.length > 0) {
            organizationText = " / " + this.props.user.organization;
        }
        return organizationText;
    }

    panelStyle() {
        const style={};
        if (this.props.user.waitlistColor()) {
            var waitlistColor = this.props.user.waitlistColor();
            // alert(1)
            if (waitlistColor == 'role-based-referral') {
                style.backgroundColor = '#B88254'
                    // alert(1)
            } else if (waitlistColor == 'referrer') {
                style.backgroundColor = '#ffcccc'
                    // alert(1)
            } else if (waitlistColor == 'not-converted-lib') {
              style.backgroundColor = 'violet'
              // alert(1)
            } else if (waitlistColor == 'mdc') {
                style.backgroundColor = '#ffffcc'
                    // alert(1)
            } else if (waitlistColor == 'ig') {
                style.backgroundColor = '#ccffcc'
                    // alert(1)
            } else if (waitlistColor == 'us-co') {
              style.backgroundColor = '#7bbfc5'
              // alert(1)
            }
            // style.bsStyle = this.props.user.waitlistColor()
        } else {
            style.backgroundColor = (this.props.user.profiles.length > 0 && this.props.user.profiles[0].profile_type == 'Model') ? "#f7fff7" : "#f7f7ff"
        }
        return style;
    }

    bio() {
        if (this.props.user.bio && this.props.user.bio.length > 0) {
            return (
                <Col xs={12} style={{textAlign: 'center'}}>
          <Row><strong>Bio</strong></Row>
          <Row style={{padding: '30px', paddingTop: '15px', whiteSpace: 'pre-line'}}>{this.props.user.bio}</Row>
        </Col>
            );
        }
        return null;
    }

    notes() {
        if (this.state.notes) {
            return (
                <Col xs={6} style={{textAlign: 'center'}}>
          <Row><strong>Notes</strong></Row>
          <Row style={{padding: '30px', paddingTop: '15px', whiteSpace: 'pre-line'}}>{this.state.notes}</Row>
        </Col>
            );
        }
        return null;
    }

    actionNotes() {
        if (this.state.action_notes) {
            return (
                <Col xs={6} style={{textAlign: 'center'}}>
          <Row><strong>Action Notes</strong></Row>
          <Row style={{padding: '30px', paddingTop: '15px', whiteSpace: 'pre-line'}}>{this.state.action_notes}</Row>
        </Col>
            );
        }
        return null;
    }

    loading() {
        if (this.state.loading) {
            return <Loading />
        }
    }

    handleSelect(e) {
        this.edit(e.target.name, e.target.value);
    }

    letOffWaitlist(mcURL, manualOrdering) {
        this.setState({ loading: true, waitlisted: false });
        const self = this;
        const update = this.props.user.letOffWaitlist(mcURL, manualOrdering, this.state.assignee);
        update.then(function(response) {
            return handleHttpResponse(response)
                .then(function(result) {
                    console.log(result);
                    self.setState({ loading: false });
                }).catch(function(err) {
                    console.log(err);
                    self.setState({ loading: false, waitlisted: true });
                })
        }).catch(function(err) {
            console.log("There was an error, please try again");
            self.setState({ loading: false, waitlisted: true });
            //**TODO: send response over to SC engineers
        })
    }

    modelsCom() {
        if (this.props.user.waitlist_entry.mc_url) {
            return (<Col xs={6} style={{marginTop: '15px'}}>
        <a target="_blank" href={"https://"+this.props.user.waitlist_entry.mc_url}>
          Models.com
        </a>
      </Col>)
        } else {
            return null;
        }
    }

    getJobPosition = (user) => {
      if (user.job_title && user.organization) return user.job_title + ' at ' + user.organization
      else if (user.job_title) return user.job_title;
      else if (user.organization) return 'at ' + user.organization;

      return ''
    }

    getUserTitle(user) {
      if (!user.profiles.length) return ''
      if (user.profiles.length > 0 && user.profiles[0].profile_type === 'Model') return user.profiles[0].data.gender + ' Model'

      return user.profiles.map((p) => [p.gender, p.profile_type].join(' ')).join(', ')
    }

    render() {
        const self = this;
        const user = this.props.user;
        return (
            <tr style={this.panelStyle()}>
              <td><img src={(user.profileImage())} width='80px' /></td>
              <td>{user.first_name} {user.last_name}</td>
              <td style={{width: '80px', maxWidth: '80px',overflowWrap: 'break-word'}}>{this.getUserTitle(user)}</td>
              <td style={{maxWidth: '140px',overflowWrap: 'break-word'}}>{this.getJobPosition(user)}</td>
              <td style={{maxWidth: '140px',overflowWrap: 'break-word'}}>{user.email}</td>
              <td style={{maxWidth: '100px',overflowWrap: 'break-word'}}>{[user.phone_country_code, user.phone_number].join(' ')}</td>
              <td style={{maxWidth: '80px', overflowWrap: 'break-word'}}>{user.website ? <a  target = '_blank' href={user.website && user.website.indexOf('http')==-1? 'http://'+ user.website : user.website}>URL</a> : null}</td>
              <td style={{maxWidth: '100px',overflowWrap: 'break-word'}}><a href= {"https://instagram.com/" + user.instagram} target = "_blank">{user.instagram && user.instagram_followers ? `${user.instagram} (${user.instagram_followers})` : user.instagram}</a></td>
              <td style={{minWidth: '350px'}}>{user.bio}</td>

              <td>
                {
                    this.props.user.albums[0] && this.props.user.albums[0].content.length > 0 &&
                  <Button bsStyle="danger"  onClick={
                    ()=>(this.props.showImageModal(user.albums[0] ? user.albums[0].content : []))
                  }>
                  View Images
                  </Button>
                }
              </td>

              {/*<td style={{minWidth: '120px'}}>*/}
              {/*  <FormGroup controlId="formControlsSelect">*/}
              {/*    <FormControl*/}
              {/*      componentClass="select"*/}
              {/*      placeholder="select"*/}
              {/*      value={self.state.assignee}*/}
              {/*      onChange={this.handleSelect.bind(this)}*/}
              {/*      name="assignee"*/}
              {/*    >*/}
              {/*      {self.props.assignees.map((assignee)=>(<option key={Math.random()} value={assignee.id}>{assignee.name}</option>))}*/}
              {/*    </FormControl>*/}
              {/*  </FormGroup>*/}
              {/*</td>*/}
              <td style={{minWidth: '110px'}}>
                <FormGroup controlId="formControlsSelect">
                  <FormControl
                    componentClass="select"
                    placeholder="select"
                    value={self.state.bucket}
                    onChange={this.handleSelect.bind(this)}
                    name="bucket"
                  >
                    {Buckets.map((bucket)=>(<option key={Math.random()} value={bucket}>{bucket}</option>))}
                  </FormControl>
                </FormGroup>
              </td>
              {/*<td style={{minWidth: '120px'}}>*/}
              {/*  <FormGroup controlId="formControlsSelect">*/}
              {/*    <FormControl*/}
              {/*      onChange={this.handleSelect.bind(this)}*/}
              {/*      componentClass="select" placeholder="select"*/}
              {/*      value={self.state.completion}*/}
              {/*      name="completion"*/}
              {/*    >*/}
              {/*      <option value="complete">Complete</option>*/}
              {/*      <option value="incomplete">Incomplete</option>*/}
              {/*      <option value="partiallyComplete">Partially Complete</option>*/}
              {/*    </FormControl>*/}
              {/*  </FormGroup>*/}
              {/*</td>*/}
              <td style={{minWidth: '120px'}}>
                <UserPanelOffWaitlistCol user={user} disabled={!this.state.waitlisted} onClick={
                  ()=>(this.props.showWaitlistModal(user.waitlist_entry.mc_url, self.letOffWaitlist.bind(self)))
                } />
              </td>

              <td style={{maxWidth: '150px'}}>{DateHelpers.timeStampToLabel(user.created_at.replace(" ", "T"), true)}</td>
              <td><a href= {`${Helpers.frontendURL}/profile/${user.swipecast_user_id}`} target = "_blank">VIEW</a></td>
              <td style={{minWidth: '80px', maxWidth: '130px', overflowWrap: 'break-word'}}><a href={user.waitlist_entry.mc_url} target = "_blank">{user.waitlist_entry.mc_url ? user.waitlist_entry.mc_url : ""}</a></td>
              <td>
                {user.referrer ? (
                  user.referrer.swipecast_user_id ? (
                    <a href={`${Helpers.frontendURL}/profile/${user.referrer.swipecast_user_id}`} target="_blank">
                      {user.referrer.first_name} {user.referrer.last_name}
                    </a>
                  ) : `${user.referrer.first_name} ${user.referrer.last_name}`
                ) : ''}
              </td>
          </tr>

        )
    }
}

export default UserPanel;
